import {pageEventsMap} from "./page/pageEMap";
import {userEventsMap} from "./user/userEMap";
import {portfolioEventsMap} from "./portfolio/portfolioEMap";
import {zoomEventsMap} from "./zoom/zoomEMap";
import {orderEventsMap} from "./order/orderEMap";
import {playerEventsMap} from "./player/playerEMap";

export const eventsMap = {
	...pageEventsMap,
	...userEventsMap,
	...portfolioEventsMap,
	...zoomEventsMap,
	...orderEventsMap,
	...playerEventsMap,
};